import '@/plugins/vue-composition-api'
import '@/styles/styles.scss'
import Vue from 'vue'
import { abilitiesPlugin } from '@casl/vue'
import Flutterwave from 'flutterwave-vue-v3'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import store from './store'
import http from './http'
import router from './router'
import config from './config'
import ability from './config/abilities'

Vue.config.productionTip = false

// setup permissions plugin
Vue.use(abilitiesPlugin, ability, {
  useGlobalProperties: true,
})

// setup flutterwave

Vue.use(Flutterwave, { publicKey: process.env.VUE_APP_FLWPUBLIC_KEY })

new Vue({
  store,
  vuetify,
  http,
  router,
  config,
  render: h => h(App),
}).$mount('#app')
